export enum BookingEngineField {
    CurrencySelect = 'currencySelect',
    LanguageSelector = 'languageSelector',
    PromotionalCode = 'promotionalCode',
}
